import styled from 'styled-components';

export const VehicleTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Audi Type;
`;

export const RadioButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
